import React, { useContext } from 'react'
import './AcceptInvite.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from '../../context/AuthContext';

export default function AcceptInvite() {
    const { user } = useContext(AuthContext);
    const { inviteId } = useParams();
    const navigate = useNavigate();
    const goToRegister = () => {
        navigate(`/register/${inviteId}`);
    };

  return (
    <div className='accept-link-container'>
        {!user ? (
        <>
            <div className="heading-info">
                <h2 className='heading'>
                    Accept Invite
                </h2>
                <p className='info-p'>You&apos;ve been invited! Click below to create an account.</p>
            </div>
            <div className="accept-container">
                <button className='accept-button' onClick={goToRegister}>Create Account</button>
            </div>
        </>

        ) : 
        <div className="user-is-valid">
            <p>You already have an account. Send this invite to someone who doesn&apos;t</p>
        </div>
        }
    </div>
  )
}
